import { Grid, Stack } from '@mui/material';
import { Component } from 'react';
import { Alert } from '../../components/Alert';
import { Dialog } from '../../components/dialogs/Dialog';
import { EmployeeSelector } from '../../components/selectors/EmployeeSelector';
import { withLocale, WithLocaleProps } from '../../providers/LocaleProvider';

interface AssignManagerDialogProps extends WithLocaleProps {
  organization?: any;
  user?: any;
  theme?: any;
  manager?: any;
  managers?: any;
  excludeEmployee?: any;
  position?: any;
  error?: string;
  allowNone?: boolean;
  onCancel?: () => void;
  onSave?: (e: any, position: any, manager: any) => void;
  onLoadManagers?: (force?: boolean) => void;
}

class AssignManagerDialogBase extends Component<AssignManagerDialogProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      manager: props.manager ? this.matchManagerInfo(props.manager) : null,
      noneSelected: false,
      allowNone: false,
    };

    this.matchManagerInfo(props.manager);
  }

  componentDidMount() {
    const { onLoadManagers } = this.props;
    if (onLoadManagers) onLoadManagers(true);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.managers !== this.props.managers) {
      this.matchManagerInfo(this.state.manager);
      this.forceUpdate();
    }
    if (prevProps.manager !== this.props.manager) this.setManager(this.props.manager);
  }

  onEmployeeChange(e: any, manager: any) {
    if (manager && manager.isNoneItem) this.setState({ manager: null, noneSelected: true });
    else this.setManager(manager);
  }

  setManager(manager: any) {
    this.setState({ manager: this.matchManagerInfo(manager), noneSelected: false });
  }

  matchManagerInfo(manager: any) {
    const { managers } = this.props;
    const managerInfo =
      managers && manager ? managers.employees.find((m: any) => m.jobId === manager.jobId) : null;
    if (managerInfo) {
      manager.reportsToEmployeeFullname = managerInfo.reportsToEmployeeFullname;
      manager.directReports = managerInfo.directReports;
    }
    return manager;
  }

  onSave(e: any) {
    const { onSave, position } = this.props;
    const { manager } = this.state;
    if (onSave) onSave(e, position, manager);
  }

  render() {
    const { theme, excludeEmployee, managers, onCancel, error, allowNone, translate } = this.props;
    const { manager, noneSelected } = this.state;

    return (
      <Dialog
        open={true}
        theme={theme}
        onClose={onCancel}
        fullWidth={true}
        title={translate('assignment.selectReportingManager')}
        maxWidth='sm'
        actions={[
          {
            label: translate('common.select'),
            primary: true,
            disabled: manager === null && !noneSelected,
            onClick: this.onSave.bind(this),
          },
          {
            label: translate('common.cancel'),
            onClick: onCancel,
          },
        ]}
      >
        <Stack spacing={4}>
          {error && (
            <Alert severity='error' sx={{ width: '100%' }}>
              {error}
            </Alert>
          )}
          <EmployeeSelector
            value={manager}
            theme={theme}
            managersOnly={true}
            hasNoneItem={allowNone}
            translate={translate}
            multiple={false}
            label={null}
            filterItems={(managers: any) =>
              excludeEmployee
                ? managers.filter((m: any) => m.employeeId !== excludeEmployee.employeeId)
                : managers
            }
            initialItems={managers ? managers.employees : null}
            placeholder={translate('assignment.searchManager')}
            onChange={this.onEmployeeChange.bind(this)}
            filterOptionsProps={(options: any) => options}
          />
          {manager && (
            <div>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  {translate('common.name')}
                </Grid>
                <Grid item xs={8}>
                  {manager.fullName}
                </Grid>
                <Grid item xs={4}>
                  {translate('entities.job')}
                </Grid>
                <Grid item xs={8}>
                  {manager.jobTitle}
                </Grid>
                <Grid item xs={4}>
                  {translate('assignment.reportsTo')}
                </Grid>
                <Grid item xs={8}>
                  {manager.reportsToEmployeeFullname}
                </Grid>
                <Grid item xs={4}>
                  {translate('assignment.directReports')}
                </Grid>
                <Grid item xs={8}>
                  <ul className='klay-managerdialog_directreportslist'>
                    {manager.directReports &&
                      manager.directReports.map((e: any) => (
                        <li key={Math.random().toString(36).substring(7)}>{e}</li>
                      ))}
                  </ul>
                </Grid>
              </Grid>
            </div>
          )}
        </Stack>
      </Dialog>
    );
  }
}

export const AssignManagerDialog = withLocale(AssignManagerDialogBase);
